import React from 'react';
import './PdfViewerModal.css';

/**
 * Reusable in-app PDF viewer modal that relies on the browser's native PDF toolbar.
 */
export function PdfViewerModal({ isOpen, pdfUrl, title = 'PDF preview', onClose }) {
  if (!isOpen || !pdfUrl) {
    return null;
  }

  return (
    <div className="pdf-viewer-backdrop" role="dialog" aria-modal="true" aria-label={title}>
      <div className="pdf-viewer-modal">
        <div className="pdf-viewer-header">
          <button
            type="button"
            className="pdf-viewer-close"
            onClick={onClose}
            aria-label="Close PDF preview"
          >
            ×
          </button>
          <p className="pdf-viewer-title">{title}</p>
        </div>
        <div className="pdf-viewer-body">
          <iframe
            title={title}
            src={pdfUrl}
            className="pdf-viewer-frame"
          />
        </div>
      </div>
    </div>
  );
}
